/*global GeomUtils*/

import './worker/utm';
import './worker/geomUtils';

export default GeomUtils;